import { createReducer, on } from '@ngrx/store';
import {
  getDataFlowsRequest,
  getDataFlowsSuccess,
  getDataFlowsFailure,
  setDataFlowFilters,
  getDataFlowByIdRequest,
  getDataFlowByIdSuccess,
  getDataFlowByIdFailure,
  clearSelectedDataFlow,
  updateDataFlowRequest,
  updateDataFlowSuccess,
  updateDataFlowFailure,
  addMessageRequest,
  addMessageSuccess,
  addMessageFailure,
  requestDocumentsRequest,
  requestDocumentsSuccess,
  requestDocumentsFailure,
  uploadVerifiedReportRequest,
  uploadVerifiedReportSuccess,
  uploadVerifiedReportFailure,
  submitLicenseSubmissionRequest,
  submitLicenseSubmissionSuccess,
  submitLicenseSubmissionFailure,
  addExamBookingRequest,
  addExamBookingSuccess,
  addExamBookingFailure,
  updateExamBookingStatusRequest,
  updateExamBookingStatusSuccess,
  updateExamBookingStatusFailure,
} from '../actions/data-flow.actions';
import { DataFlowFilters } from '../actions/data-flow.actions';
import { CandidateDataFlowItem } from '../../shared/models/data-flow-api.model';

export interface DataFlowState {
  loading: boolean;
  updating: boolean;
  message: string;
  dataFlows: CandidateDataFlowItem[];
  selectedDataFlow: any;
  filters: DataFlowFilters;
  total: number;
}

const defaultFilters: DataFlowFilters = {
  pageSize: 10,
  pageNumber: 1,
};

export const initialState: DataFlowState = {
  loading: false,
  updating: false,
  message: '',
  dataFlows: [],
  selectedDataFlow: null,
  filters: defaultFilters,
  total: 0,
};

export const dataFlowReducer = createReducer(
  initialState,
  on(getDataFlowsRequest, (state, { filters }) => ({
    ...state,
    filters,
    loading: true,
    message: '',
  })),
  on(getDataFlowsSuccess, (state, { data, total }) => ({
    ...state,
    loading: false,
    dataFlows: data,
    total,
  })),
  on(getDataFlowsFailure, (state, { message }) => ({
    ...state,
    loading: false,
    message,
  })),
  on(setDataFlowFilters, (state, { filters }) => ({
    ...state,
    filters,
  })),
  on(getDataFlowByIdRequest, (state) => ({
    ...state,
    loading: true,
    message: ''
  })),
  on(getDataFlowByIdSuccess, (state, { data }) => ({
    ...state,
    loading: false,
    selectedDataFlow: data
  })),
  on(getDataFlowByIdFailure, (state, { message }) => ({
    ...state,
    loading: false,
    message
  })),
  on(clearSelectedDataFlow, (state) => ({
    ...state,
    selectedDataFlow: null
  })),
  on(updateDataFlowRequest, (state) => ({
    ...state,
    updating: true,
    message: ''
  })),
  on(updateDataFlowSuccess, (state, { data }) => ({
    ...state,
    updating: false,
    selectedDataFlow: {
      ...data,
      candidate: state.selectedDataFlow?.candidate
    }
  })),
  on(updateDataFlowFailure, (state, { message }) => ({
    ...state,
    updating: false,
    message
  })),
  on(addMessageRequest, (state) => ({
    ...state,
    updating: true,
    message: ''
  })),
  on(addMessageSuccess, (state, { data }) => ({
    ...state,
    updating: false,
    selectedDataFlow: data
  })),
  on(addMessageFailure, (state, { message }) => ({
    ...state,
    updating: false,
    message
  })),
  on(requestDocumentsRequest, (state) => ({
    ...state,
    updating: true,
    message: ''
  })),
  on(requestDocumentsSuccess, (state, { data }) => ({
    ...state,
    updating: false,
    selectedDataFlow: data
  })),
  on(requestDocumentsFailure, (state, { message }) => ({
    ...state,
    updating: false,
    message
  })),
  on(uploadVerifiedReportRequest, (state) => ({
    ...state,
    updating: true,
    message: ''
  })),
  on(uploadVerifiedReportSuccess, (state, { data }) => ({
    ...state,
    updating: false,
    selectedDataFlow: data
  })),
  on(uploadVerifiedReportFailure, (state, { message }) => ({
    ...state,
    updating: false,
    message
  })),
  on(submitLicenseSubmissionRequest, (state) => ({
    ...state,
    updating: true,
    message: ''
  })),
  on(submitLicenseSubmissionSuccess, (state, { data }) => ({
    ...state,
    updating: false,
    selectedDataFlow: data
  })),
  on(submitLicenseSubmissionFailure, (state, { message }) => ({
    ...state,
    updating: false,
    message
  })),
  on(addExamBookingRequest, (state) => ({
    ...state,
    updating: true,
    message: ''
  })),
  on(addExamBookingSuccess, (state, { data }) => ({
    ...state,
    updating: false,
    selectedDataFlow: data
  })),
  on(addExamBookingFailure, (state, { message }) => ({
    ...state,
    updating: false,
    message
  })),
  on(updateExamBookingStatusRequest, (state) => ({
    ...state,
    updating: true,
    message: ''
  })),
  on(updateExamBookingStatusSuccess, (state, { data }) => ({
    ...state,
    updating: false,
    selectedDataFlow: data
  })),
  on(updateExamBookingStatusFailure, (state, { message }) => ({
    ...state,
    updating: false,
    message
  })),
);
